import { render, staticRenderFns } from "./LanguagePairFilter.vue?vue&type=template&id=508d23a6&"
import script from "./LanguagePairFilter.vue?vue&type=script&lang=js&"
export * from "./LanguagePairFilter.vue?vue&type=script&lang=js&"
import style0 from "./LanguagePairFilter.vue?vue&type=style&index=0&id=508d23a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports